import { css } from '@emotion/react';
import colors from '../../../Themes/colors';

const { black, orange, white } = colors;

export const InputStyle = css({
    '@media(min-width: 300px)': {
        padding: '12px 15px',
    },
    '@media(min-width: 1200px)': {
        paddingBottom: 5,
        height: 45,
        border: '1px solid #E6DFD8',
        borderRadius: 8,
        color: 'black',
        fontSize: '1.4rem',
        fontFamily: 'AcuminRPro',

        ':disabled': {
            backgroundColor: '#eeeeee',
        },
    },
});

export const AccountTitle = css({
    paddingLeft: '32px',
    marginBottom: '20px',
    fontSize: '23px',
    fontWeight: 700,
    color: black,
});

export const AccountLabel = css({
    fontSize: '16px',
    fontWeight: 400,
    fontFamily: 'AcuminRPro',
    color: black,
});

export const AccountSubTitle = css({
    padding: '32px',
    marginTop: 20,
    fontSize: '1.6rem',
    fontWeight: 700,
    color: black,
    letterSpacing: 0.8,
});

export const SaveButton = css({
    font: '18px Archivo-Regular, sans-serif',
    color: white,
    backgroundColor: orange,
    borderColor: orange,
    '&:hover': { background: white, borderColor: orange, color: orange },
    padding: '10px 20px',
});

export const CancelButton = css({
    font: '18px Archivo-Regular, sans-serif',
    color: orange,
    backgroundColor: white,
    borderColor: orange,
    '&:hover': { background: orange, borderColor: orange, color: white },
    padding: '10px 20px',
});

export const AccountFormGroup = css({
    height: '95px',
    marginBottom: '0px',
});

export const AccountInput = css({
    height: '50px',
    padding: '0px 16px',
    borderRadius: '8px',
    border: '1px solid #E6DFD8',
    backgroundColor: '#FFFEFD',

    fontFamily: 'AcuminRPro',
    fontSize: '14px',
    marginBottom: '16px',

});
